import { useBrandingContext, useCustomLocale } from '@group-link-one/gl-components';
import type { CustomLocale } from '../Types/Login.locale.types';
import type { IBranding } from '@/Branding';

interface UseLoginTranslationReturn {
  customLocale: CustomLocale;
  brandingName: string;
}

/**
 * Hook for login translations and error messages
 * Encapsulates branding context and locale logic
 * @returns Translation utilities and branding info
 */
export const useLoginTranslation = (): UseLoginTranslationReturn => {
  const { brandingData } = useBrandingContext() as { brandingData: IBranding };
  const { customLocale } = useCustomLocale(brandingData.Onboard.login.locale);

  return {
    customLocale: customLocale as CustomLocale,
    brandingName: brandingData.BrandingName,
  };
};
